import React from 'react';
import Header from './Header';
import Footer from './Footer';
import WarningBanner from './WarningBanner';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <WarningBanner />
      <Header />
      <main className="flex-grow pt-32">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;

